import { render, staticRenderFns } from "./MintalMesQualitySelfInspectPelletizeEdit.vue?vue&type=template&id=52d5b89d&"
import script from "./MintalMesQualitySelfInspectPelletizeEdit.vue?vue&type=script&lang=js&"
export * from "./MintalMesQualitySelfInspectPelletizeEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports